module.exports = __webpack_public_path__ + "img/B23-20190415_02.e83fdd2b.jpg";